module.exports = "/img/2.ff37b1.webp";